const STATUS_TONE_MAP = Object.freeze({
  finalizado: Object.freeze({
    color: "#15803d",
    background: "#f0fdf4",
    border: "#86efac",
  }),
  pendiente: Object.freeze({
    color: "#475569",
    background: "#f8fafc",
    border: "#cbd5e1",
  }),
  en_curso: Object.freeze({
    color: "#2563eb",
    background: "#eff6ff",
    border: "#93c5fd",
  }),
  cancelado: Object.freeze({
    color: "#7c6d86",
    background: "#f8f6fa",
    border: "#cfc7d4",
  }),
  incidencia: Object.freeze({
    color: "#c2410c",
    background: "#fff7ed",
    border: "#fdba74",
  }),
  error: Object.freeze({
    color: "#dc2626",
    background: "#fef2f2",
    border: "#fca5a5",
  }),
  recogida: Object.freeze({
    color: "#be185d",
    background: "#fdf2f8",
    border: "#f9a8d4",
  }),
  entrega: Object.freeze({
    color: "#7c3aed",
    background: "#f5f3ff",
    border: "#c4b5fd",
  }),
});

export default STATUS_TONE_MAP;
